<ng-container *transloco="let t">
<ng-template #asset>
  @if (inEditMode) {
    <div class="d-flex mb-5">
      <div class="col-sm-6 col-form-label fw-bold fs-6 editor-label">{{ t('wizard.assets.dontLetUserSkipWithoutAssets') }}</div>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
        <input class="form-check-input h-20px w-30px" type="checkbox"
          name="dontLetUserSkipWithoutAssets" id="dontLetUserSkipWithoutAssets"
          [(ngModel)]="step.dontLetUserSkipWithoutAssets" />
        <label class="form-check-label" for="dontLetUserSkipWithoutAssets">
          {{step.dontLetUserSkipWithoutAssets ? t('common.yes') : t('common.no')}}
        </label>
      </div>
    </div>
    <div class="d-flex mb-5">
      <div class="col-sm-6 col-form-label fw-bold fs-6 editor-label">{{ t('wizard.assets.enableAccountGroupingByInstitution') }}</div>
      <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
        <input class="form-check-input h-20px w-30px" type="checkbox"
          name="enableAccountGroupingByInstitution" id="enableAccountGroupingByInstitution"
          [(ngModel)]="step.enableAccountGroupingByInstitution" />
        <label class="form-check-label" for="enableAccountGroupingByInstitution">
          {{step.enableAccountGroupingByInstitution ? t('common.yes') : t('common.no')}}
        </label>
      </div>
    </div>
  }
  <div class="fv-row" id="assets-main">
    <asset-list
      [fieldConfig]="step.fieldConfig"
      [enableGrouping]="!!step.enableAccountGroupingByInstitution"
      [assets]="mortgage.assets"
      (addAtInstitutionClicked)="onAddAtInstitution($event)">
    </asset-list>
    <div class="row">
      <div class="col-xl-12 mb-10">
        <div class="d-flex justify-content-center flex-wrap gap-4">
          @if (step.enableAccountGroupingByInstitution) {
            <label (click)="onAddAccountClicked()" class="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center" style="cursor: pointer;">
              <span class="svg-icon svg-icon-2x me-5 duotone-home-svg-mobile" style="margin-top: -4px;">
                <stockholm-bank-svg-icon></stockholm-bank-svg-icon>
              </span>
              <span class="d-block fw-bold text-start">
                @if (!inEditMode) {
                  <span class="text-dark fw-bolder d-block fs-5 mb-2">
                    {{ config | localizedLabel:'addAccountActionLabel':'wizard.assets.addAccount' }}
                  </span>
                  <span class="text-gray-400 fw-bold fs-6">{{ config | localizedLabel:'addAccountHintLabel':'wizard.assets.addAccountHint' }}</span>
                }
                @if (inEditMode) {
                  <input name="addAccountActionLabel" type="text"
                    class="form-control form-control-solid fs-5 fw-bolder mb-2" [ngModel]="i18n.get(config, 'addAccountActionLabel')" (ngModelChange)="i18n.set(config, 'addAccountActionLabel', $event)"
                    [placeholder]="config | localizedLabel:'addAccountActionLabel':'wizard.assets.addAccount'" />
                  <input name="addAccountHintLabel" type="text"
                    class="form-control form-control-solid fs-6" [ngModel]="i18n.get(config, 'addAccountHintLabel')" (ngModelChange)="i18n.set(config, 'addAccountHintLabel', $event)"
                    [placeholder]="config | localizedLabel:'addAccountHintLabel':'wizard.assets.addAccountHint'" />
                }
              </span>
            </label>
          }
          <label (click)="onAddAssetClicked()" class="btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center" style="cursor: pointer;">
            <span class="svg-icon svg-icon-2x me-5 duotone-home-svg-mobile" style="margin-top: -4px;">
              <duotone-coins-svg-icon></duotone-coins-svg-icon>
            </span>
            <span class="d-block fw-bold text-start">
              @if (!inEditMode) {
                <span class="text-dark fw-bolder d-block fs-5 mb-2">
                  {{ config | localizedLabel:'addAssetActionLabel':(step.enableAccountGroupingByInstitution
                          ? 'wizard.assets.addOtherAsset'
                          : (activeAssetCount > 0 ? 'wizard.assets.addAnotherAsset' : 'wizard.assets.addAsset')) }}
                </span>
              }
              @if (inEditMode) {
                <input name="addAssetActionLabel" type="text"
                  class="form-control form-control-solid fs-5 fw-bolder" [ngModel]="i18n.get(config, 'addAssetActionLabel')" (ngModelChange)="i18n.set(config, 'addAssetActionLabel', $event)"
                  [placeholder]="config | localizedLabel:'addAssetActionLabel':(step.enableAccountGroupingByInstitution ? 'wizard.assets.addOtherAsset' : (activeAssetCount > 0 ? 'wizard.assets.addAnotherAsset' : 'wizard.assets.addAsset'))" />
              }
              <span class="text-gray-400 fw-bold fs-6"></span>
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<wizard-step-template [stepMainTemplate]="asset" [stepComponent]="this" [step]="step"></wizard-step-template>
</ng-container>
